import { useTheme } from 'foundations-theming/utils';
import { useTheme as useSpecialtyTheme } from 'foundations-theming-specialty/utils';
import { SECONDARY, TERTIARY, TRANSPARENT } from '../../../types/AIButtonUseTypes';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeStarSVG = ({
  className,
  use,
  isDisabled
}) => {
  const trellisTheme = useTheme();
  const specialtyTheme = useSpecialtyTheme();
  let color = trellisTheme.color['fill-surface-default'];
  if (isDisabled) {
    color = trellisTheme.color['icon-core-disabled'];
  } else if (use === SECONDARY || use === TRANSPARENT) {
    color = specialtyTheme.color['breeze-fill-primary-default'];
  } else if (use === TERTIARY) {
    color = trellisTheme.color['icon-core-default'];
  }
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.5752 6.57976C10.2249 6.57976 7.42484 3.78266 7.42484 0.430004C7.42484 0.19812 7.23174 0.00488281 7.00001 0.00488281C6.76829 0.00488281 6.57519 0.19812 6.57519 0.430004C6.57519 3.78266 3.77518 6.57976 0.424829 6.57976C0.188276 6.57976 0 6.773 0 7.00488C0 7.2416 0.188276 7.43 0.424829 7.43C3.77518 7.43 6.57519 10.2271 6.57519 13.5798C6.57519 13.8116 6.76829 14.0049 7.00001 14.0049C7.23174 14.0049 7.42484 13.8116 7.42484 13.5798C7.42484 10.2271 10.2249 7.43 13.5752 7.43C13.8117 7.43 14 7.23677 14 7.00488C14 6.76817 13.8117 6.57976 13.5752 6.57976Z",
      fill: color
    })
  });
};